import { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { UIContext } from '../../contexts/UIContext';

import { useGeoLocation } from '../../hooks/useGeoLocation';
import { useGetWorkingArea } from '../../hooks/useWorkingAreasService';

import { Button, Typography } from '@mui/material';
import Header from '../../components/Header/Header';
import BottomMenu from '../../components/BottomMenu/BottomMenu';
import SimpleProfileCard from '../../components/SimpleProfileCard/SimpleProfileCard';
import MapVisualizer from '../../components/MapVisualizer/MapVisualizer';
import InformationDialogue from '../../components/InformationDialogue/InformationDialogue';

import './WorkingAreaDetails.scss';

function WorkingAreaDetails() {
  const { isAuthorized } = useContext(AuthContext);
  const {
    INFO_DIALOGUE_MSGS,
    setOpenInfoDialogue,
    handleCloseInfoDialogue,
    openInfoDialogue,
    infoMsgTitle,
    infoMsgLabel,
    infoMsgContent
  } = useContext(UIContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [ lat, lng, err ] = useGeoLocation()
  const [, workingArea] = useGetWorkingArea({
    workingAreaId: location?.state?.workingAreaId
  });
  const [seeMap, setSeeMap] = useState(false);
  const agentFirstName = workingArea?.agent?.platform_user?.user?.first_name;
  const agentLastName = workingArea?.agent?.platform_user?.user?.last_name;
  const agent = `${agentFirstName} ${agentLastName ? agentLastName : ''}`;
  const agentPictureURL = workingArea?.agent?.platform_user?.user?.profile_picture?.url;
  const agentMangerFirstName = workingArea?.agents_manager?.platform_user?.user?.first_name;
  const agentManagerLastName = workingArea?.agents_manager?.platform_user?.user?.last_name;
  const agentManager = `${agentMangerFirstName} ${agentManagerLastName ? agentManagerLastName : ''}`;
  const agentManagerPictureURL = workingArea?.agents_manager?.platform_user?.user?.profile_picture?.url;
  const description = workingArea?.description;

  useEffect(() => {
    if (!isAuthorized) navigate('/login');
  }, [isAuthorized, navigate]);

  useEffect(() => {
    if (err) {
      setOpenInfoDialogue({
        open: true,
        msgId: INFO_DIALOGUE_MSGS.LOCATION_IS_REQUIRED_TO_USE_THIS_FEATURE,
        callback: () => navigate(-1)
      });
    }
  }, [
    INFO_DIALOGUE_MSGS.LOCATION_IS_REQUIRED_TO_USE_THIS_FEATURE,
    err,
    navigate,
    setOpenInfoDialogue
  ]);

  function handleClickSeeMap() {
    setSeeMap(!seeMap);
  }

  return (
    <div className="inner-page working-area-details-page">
      <Header
        showBackBtn
        hideBackBtnLabel
        pageTitle="Área de Trabalho"
      />
      <div className="inner-page-content-container">
        {!seeMap ? (
          <div className="working-area-meta-info">
            <div className="working-area-field">
              <Typography variant="label" component="label">Agente</Typography>
              <SimpleProfileCard
                userName={agent}
                userPictureURL={agentPictureURL}
              />
            </div>
            <div className="working-area-field">
              <Typography variant="label" component="label">Supervisor</Typography>
              <SimpleProfileCard
                userName={agentManager}
                userPictureURL={agentManagerPictureURL}
              />
            </div>
            <div className="working-area-field">
              <Typography variant="label" component="label">Descrição</Typography>
              <Typography variant="p" component="p">{description}</Typography>
            </div>
            <div className="working-area-field">
              <Typography variant="label" component="label">Geo localização</Typography>
              <Button onClick={handleClickSeeMap}>Veja no mapa</Button>
            </div>
          </div>
        ) : workingArea && lat && lng && (
          <MapVisualizer
            className="working-area-map"
            workingArea={workingArea}
            handleClickHideMap={handleClickSeeMap}
          />
        )}
      </div>
      <InformationDialogue
        title={infoMsgTitle}
        confirmLabel={infoMsgLabel}
        open={openInfoDialogue}
        onClose={handleCloseInfoDialogue}
      >
        {infoMsgContent}
      </InformationDialogue>
      <BottomMenu />
    </div>
  );
}

export default WorkingAreaDetails;
